import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setInfo(data); setState("paid"); return; }
        if (data.payment_status === "expired" || data.status === "failed") { setState("failed"); return; }
      } catch (e) { /* keep trying */ }
      if (attempts >= 8) { setState("failed"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="payment-success-page">
      <div className="max-w-lg w-full text-center p-12 rounded-3xl bg-white border" style={{ borderColor: "rgba(212,175,55,0.3)" }}>
        {state === "checking" && (
          <>
            <Loader2 size={56} className="animate-spin mx-auto" style={{ color: "var(--gold)" }} />
            <h1 className="font-display text-3xl mt-6" style={{ color: "var(--navy)" }}>Confirming your payment…</h1>
            <p className="font-body font-light mt-3" style={{ color: "var(--muted)" }}>Just a moment while we secure your reservation.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto" style={{ color: "var(--gold)" }} />
            <h1 className="font-display text-4xl mt-6" style={{ color: "var(--navy)" }}>Reservation secured!</h1>
            <p className="font-body font-light mt-3" style={{ color: "var(--muted)" }}>
              Thank you — your payment of ${info?.amount} was received. Milly will be in touch to confirm your lesson schedule.
            </p>
            <Link to="/" className="btn-primary mt-8">Back to Home</Link>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle size={56} className="mx-auto" style={{ color: "var(--navy)" }} />
            <h1 className="font-display text-3xl mt-6" style={{ color: "var(--navy)" }}>We couldn't confirm payment</h1>
            <p className="font-body font-light mt-3" style={{ color: "var(--muted)" }}>
              If you were charged, please call 561-577-6346 and we'll sort it out right away.
            </p>
            <Link to="/contact" className="btn-secondary mt-8">Try Again</Link>
          </>
        )}
      </div>
    </div>
  );
}
